<template>
  <section id="case-information-view" class="all-cases-view" v-loading="loading">
    <div class="listings-navbar">
      <div class="title-block">
        <div class="float-right" v-if="this.caseData && this.caseData.length && !isCompletedEMR">
          <el-popover placement="top-start" title="" width="200" trigger="hover" content="Select reports to Send EMR"
            v-if="!selectedEmr">
            <el-button type="primary">Send To EMR <i class="el-icon-s-promotion"></i></el-button>
          </el-popover>
          <el-button type="primary" @click="askEmrConfig = true" v-else>
            Send To EMR <i class="el-icon-s-promotion"></i>
          </el-button>
        </div>
        <div class="icon-block">
          <div class="icon-text">
            <h3>Finalized Reports</h3>
          </div>
        </div>
      </div>
    </div>
    <div class="resend-emr" v-if="
      getSingleEMROrder &&
      getSingleEMROrder.status != 'SENT' &&
      selectedCaseIds &&
      selectedCaseIds.length
    ">
      <el-button @click="resendEmr">Resend EMR</el-button>
    </div>
    <div class="primary-content-view-new">
      <div class="listings listings__table listings__all-cases" id="all-cases-listings">
        <el-table :data="caseData" ref="multipleTable" class="mx-auto hidden-sm-and-down" height="400"
          @selection-change="handleSelectionChange($event)">
          <el-table-column type="selection" width="60" :selectable="canSelectRow"></el-table-column>
          <el-table-column label="Date & Time" width="190">
            <template #default="scope">
              <div v-if="scope.row.emr_result_sent_on" class="d-flex">
                <div class="date pr-10">
                  {{
                    momentWithTimezone(
                      scope.row.emr_result_sent_on,
                      "MM-DD-YYYY hh:mm A"
                    )
                  }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Title" min-width="360">
            <template #default="scope">
              {{ scope.row.title }}
            </template>
          </el-table-column>

          <el-table-column width="250" class="text-center" label="EMR Sent Status">
            <template #default="{ row }">
              <el-tag :type="getStatusType(row.emr_result_sent_status)" effect="light"
                v-if="row.emr_result_sent_status">{{ row.emr_result_sent_status }}</el-tag>
            </template>
          </el-table-column> </el-table><br />
      </div>
    </div>
    <div>
      <el-dialog title="EMR " v-model="askEmrConfig" width="30%" :before-close="handleEmrConfigClose"
        v-loading="loading">
        <span>
          <label>Result Status*:</label>
          <el-select v-model="emrResultStatus" placeholder="Select result status">
            <el-option v-for="item in resultStatusOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </span>
        <template class="dialog-footer">
          <el-button @click="handleEmrConfigClose">Cancel</el-button>
          <el-button type="primary" @click="sendReportToEmr">Send to EMR</el-button>
        </template>
      </el-dialog>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import FileDownloadHelper from "@/mixins/FileDownloadHelper";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  mixins: [UserPermissionsHelper, FileDownloadHelper],
  created() { },
  async mounted() {
    this.finalizedReports();
  },
  computed: {
    ...mapGetters("emrOrders", [
      "getSingleEMROrder",
      "getSendReportStatus",
      "getSingleEMROrderReports",
    ]),

    getStatusType() {
      return (status) => {
        if (
          status == "SENT" ||
          status == "COMPLETED" ||
          status == "CORRECTED"
        ) {
          return "success";
        } else if (status == "PENDING" || status == "QUEUED") {
          return "warning";
        } else if (status == "ERROR" || status == "QUEUED") {
          return "danger";
        } else {
          return "";
        }
      };
    },
    selectedEmr() {
      let selectedFiles = this.selectedCaseIds;
      return Object.keys(selectedFiles).length > 0;
    },
    isCompletedEMR() {
      return this.getSingleEMROrder &&
        this.getSingleEMROrder.status &&
        ["COMPLETED", "QUEUED"].indexOf(this.getSingleEMROrder.status) != -1
        ? true
        : false;
    },
  },
  data() {
    return {
      loading: false,
      caseId: "",
      caseData: [],
      selectedCaseIds: [],
      selectedReports: [],

      // emr options
      askEmrConfig: false,
      resultStatusOptions: [
        {
          label: "Completed",
          value: "COMPLETED",
        },
        {
          label: "Corrected",
          value: "CORRECTED",
        },
      ],
      emrNotes: "",
      emrResultStatus: "COMPLETED",
    };
  },
  methods: {
    async resendEmr() {
      try {
        this.loading = true;
        let params = {
          order_id: this.$route.params.order_id,
          notes: [this.emrNotes],
          result_status: this.emrResultStatus,
        };
        params.finalized_report_ids = this.selectedCaseIds;
        params.test_report_ids = this.selectedCaseIds;
        await this.$store.dispatch("emrOrders/sendReportToEmr", params);
        this.loading = false;

        if (this.getSendReportStatus) {
          successNotification("Report(s) ReSent Successfully");
          window.location.reload();
        } else {
          errorNotification("Error while resending report");
        }
      } catch (err) {
        console.log(err);
      }
    },
    async finalizedReports() {
      this.loading = true;
      if (this.$route.params.order_id) {
        await this.$store.dispatch("emrOrders/fetchFinalizedReportsData", {
          order_id: this.$route.params.order_id,
        });
        this.caseData = this.getSingleEMROrderReports;
      }
      this.loading = false;
    },
    canSelectRow(row) {
      return row.emr_result_sent_status !== "SENT";
    },

    handleSelectionChange(rows) {
      if (rows) {
        this.selectedCaseIds = [];
        for (let caseData of rows) {
          this.selectedCaseIds.push(caseData._id);
          this.selectedReports.push(caseData);
        }
      } else {
        this.selectedCaseIds = [];
      }
    },
    async sendReportToEmr() {
      try {
        this.loading = true;
        let params = {
          order_id: this.$route.params.order_id,
          notes: [this.emrNotes],
          result_status: this.emrResultStatus,
        };
        params.finalized_report_ids = this.selectedCaseIds;
        params.test_report_ids = this.selectedCaseIds;

        // WE HAVE TO CHECK AND DOWNLOAD THE Reports if downloaded path is not existed
        await this.downloadStatus();

        await this.$store.dispatch("emrOrders/sendReportToEmr", params);
        this.loading = false;

        if (this.getSendReportStatus) {
          successNotification("Report(s) Sent Successfully");
          this.askEmrConfig = false;
          window.location.reload();
        } else {
          errorNotification("Error while sending report");
        }
      } catch (err) {
        console.log(err);
      }
    },

    async downloadStatus() {
      for (let i = 0; i < this.selectedReports.length; i++) {
        let report = this.selectedReports[i];
        if (!report.test_report_source) {
          await this.onDownloadReport(report);
        }
      }
    },

    async onDownloadReport(report) {
      try {
        await this.generateReport(report);
      } catch (err) {
        console.log(err);
      }
    },

    async generateReport(report) {
      await this.$store.dispatch("cases/generateTestReport", {
        accession_id: this.getSingleEMROrder.accession_id,
        case_type: report.case_type,
        report_id: report.report_id,
        test_results_id: report.test_results_id,
        result_file_id: report.result_file_id,
        skip_download: true,
      });
    },
    handleEmrConfigClose() {
      this.$confirm("Are you sure to don't send this finalized report to EMR?")
        .then(() => {
          this.askEmrConfig = false;
        })
        .catch(() => { });
    },
  },
};
</script>
<style scoped>
.resend-emr {
  justify-content: flex-end;
  display: flex;
}
</style>
